<template>
  <div class="look-book" v-show="show" @click="handleCloseBook">
    <div class="look-book-content"></div>
  </div>
</template>

<script>
export default {
  name: 'look-book',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleCloseBook() {
      this.$emit('CloseBook')
    }
  }
}
</script>

<style lang="scss" scoped>
.look-book {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00051a;
  z-index: 1001;
  .look-book-content {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -120.5px;
    width: 100%;
    height: 241px;
    background-color: red;
  }
}
</style>
